/**
 * Maps dashboard UI role to GET /api/notifications/my?side=…
 * Server filters by notification type (see NotificationSideFilter on backend).
 */
export const NOTIFICATION_SIDES = {
  ALL: 'ALL',
  LANDLORD: 'LANDLORD',
  BNB_HOST: 'BNB_HOST',
  TENANT: 'TENANT',
};

/**
 * @param {string | null | undefined} userRole - Dashboard role label (e.g. "Landlord", "Airbnb Host")
 * @returns {'ALL' | 'LANDLORD' | 'BNB_HOST' | 'TENANT'}
 */
export function getNotificationSideForUserRole(userRole) {
  const role = String(userRole || '').trim();

  if (role === 'Landlord' || role === 'Agent') {
    return NOTIFICATION_SIDES.LANDLORD;
  }
  if (role === 'Airbnb Host' || role === 'BNB Host') {
    return NOTIFICATION_SIDES.BNB_HOST;
  }
  if (role === 'Tenant') {
    return NOTIFICATION_SIDES.TENANT;
  }

  return NOTIFICATION_SIDES.ALL;
}
